import PropTypes from 'prop-types';

export const CapBoxPropTypes = {
  auth: PropTypes.object.isRequired,
  capFindingsData: PropTypes.object.isRequired,
  capFindingsLoading: PropTypes.bool.isRequired,
  checklists: PropTypes.array.isRequired,
  jobId: PropTypes.number.isRequired,
  jobStatus: PropTypes.string.isRequired,
  reloadCapFindings: PropTypes.func.isRequired,
  updateCapQueryCache: PropTypes.func.isRequired,
  overallCapStatus: PropTypes.string,
  setJobOverallCapStatus: PropTypes.func
};

export const CapBoxDefaultProps = {
  overallCapStatus: null
};
